export default {
  uploadedBatchAdjustments: [],
  uploadingBatchAdjustments: false,
  importingBatchAdjustments: false,
};
